import * as Yup from 'yup'

const Validation = Yup.object().shape({
  titles: Yup.array().of(Yup.string().max(50, 'Title is too long.')),
})

export default Validation
